;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { QogitaSellersLogoWordmark } from '@qogita/ui/qogita-sellers-logo'

type LogoProps = {
  className?: string
}

export function Logo(props: LogoProps) {
  const logoProps = {
    theme: 'black',
    className: 'h-[53px] w-[144px]',
    ...props,
  } as const

  return <QogitaSellersLogoWordmark {...logoProps} />
}
